export const enum Pages {
  // System
  ROOT = '/',
  AUTH_CALLBACK = '/callback',
  NO_PERMISSIONS = '/wait',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = 'not-found',
  CHANGE_PASSWORD = 'profile/change-password',

  // Основна навігація
  PERSONAL_ACCOUNTS = 'personal-accounts',
  BUILDING_PROFILES = 'building-profiles',
  OPERATIONAL_CONSUMPTION = 'operational-consumption',
  ACTUAL_CONSUMPTION = 'actual-consumption',
  DATA_CORRECTION = 'data-correction',
  ORDERED_CAPACITY = 'ordered-capacity',
  UNALLOCATED_METER_READINGS = 'unallocated-meter-readings',
  GAS_DISTRIBUTION_STATIONS = 'gas-distribution-stations',
  GAS_THREADS = 'gas-threads',
  SECTORS = 'sectors',
  SECTOR_BRIDGES = 'sector-bridges',
  BRIDGE_ACTS = 'bridge-acts',
  GAS_ROUTES = 'gas-routes',
  OPERATING_GAS_ROUTES = 'active',
  ALLOWED_ROUTES = 'allowed-routes',
  UNDISTRIBUTED_PAYMENTS = 'undistributed-payments',
  PAYMENT_IMPORTS = 'payment-imports',

  // Act Form
  METERING_POINT_ACT = 'metering-point-act',
  BUILDING_PROFILE_ACT = 'building-profile-act',
  VIOLATION_ACTS = 'violation-acts',

  // Вкладена навігація
  METERING_NODE = 'metering-node',
  GAS_CONSUMING_EQUIPMENT = 'gas-consuming-equipment',
  DOCUMENTS_AND_FILES = 'documents-and-files',
  METER_READINGS = 'meter-readings',
  HISTORY = 'history',
  ARCHIVE = 'archive',
  CONSUMPTION = 'consumption',
  DOCUMENTS_AND_ACTS = 'documents-and-acts',
  LEDGER = 'ledger',
  PAYMENT = 'payment',

  // Організація: the same parts as the legacy pages of @gasbi/shared/web/Organization navigate to (GSB-8317)
  EMPLOYEES = 'employees',
  SUBDIVISIONS = 'subdivisions',
  ROLES = 'roles',
  ORGANIZATIONS = 'organizations',
}
